import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import Swal from 'sweetalert2'
import ReactPaginate from 'react-paginate'
import Loader from 'react-js-loader'
import loader from '../loder.gif'
import { Link } from 'react-router-dom'
import admindata from '../../components/admindata'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import { apiRequest } from '../../store/allApi'

import { dateFormat } from '../../utils/dateTime'
const WalletHistory = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState([])
  const [startDate, setStartDate] = useState(null)
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const id = localStorage.getItem("id")
    const meedata = localStorage.getItem("uData")
const userData = JSON.parse(meedata);
  //use for pagination..
  let [limit, setLimit] = useState(10)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
  const permission1 = localStorage.getItem("PData");
  const pdata = JSON.parse(permission1);

  //user for searching..
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState("Phone")
  const [findByStatus, setFindByStatus] = useState(0)

  //   searching handler
  const searchHandler = event => {
    let key = event.target.value

    setSearchList(key)
  }
  //   search by status handler
  const searchByStatus = event => {
    setSearchType("0")
    let key = event.target.value
    setFindByStatus(key)
  }

  //react paginate..
  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
    // scroll to the top
    //window.scrollTo(0, 0)
  }

  const profle =async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
     try {
          const res = await apiRequest(`history/Security_Deposit/?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}&date=${startDate}`,"GET", null,headers)
         if (res.data) {
              setUser(res.data.admin)
        setNumberOfPages(res.data.totalPages)
        //$('table').dataTable();
         }
            } catch (e) {
              setLoading(false);
            }
            finally {
            }
  }

const imageopen = (image) => {
      Swal.fire({
        title: "Pay Qr Code",
        text: "",

        imageUrl: baseUrl+image,
        imageWidth: 400,
        imageHeight: 300,
        imageAlt: "Custom image"
      })
    }


  function daterange (s, e) {
    if (s) {
      setStartDate(s)
    }
     
    }

  useEffect(() => {
    profle()
  }, [pageNumber, limit, searchList, searchType, findByStatus, startDate])

  if (user == undefined) {
    return null
  }

  const Invoice = data => {
    const userData = { data }
    // setUser(userData);
    console.log(userData)
    history.push('/invoice', { userData })
  }

  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={<img src={loader} alt='Loading...' />}
            color={'#000'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card '>
            <div className='card-body text-light table_bg'>
              <h4 className='dashboard_heading'>Agent Wallet History</h4>

              {/* searching */}
              <div className='row'>
                <select
                  className='form-control col-sm-3 m-2'
                  id='searchType'
                  name='searchtype'
                  onChange={e => setSearchType(e.target.value)}
                >
                  <option value='0'>Select Search by</option>
                  <option value='Phone'>Phone</option>
                  <option value='_id'>TxnId</option>
                  <option value='amount'>Amount</option>
                </select>
                <input
                  type='text'
                  placeholder='Search...'
                  className='form-control col-sm-4 m-2'
                  onChange={searchHandler}
                />
               
                <select
                  className='form-control col-sm-1 m-1 bg-dark text-light'
                  id='pagelimit'
                  name='pagelimit'
                  onChange={setpageLimit}
                >
                  <option value='10'>Set limit</option>
                  <option value='20'>20</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                  <option value='500'>500</option>
                </select>
{/* 
                <input
              type="datetime-local"
              name="DOB"
              placeholder="Select Data"
              value={startDate}   onChange={(e) => daterange(e.target.value)}
              required
            /> */}
              </div>

              <div className='table-responsive'>
                <table className='table text-light'>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Mobile</th>
                      <th>Name</th>
                      <th>Balance</th>
                      <th>Closing Balance</th>
                      <th>Action</th>
                      <th>Reason</th>
                      <th>Status</th>
                      <th>Time</th>
                      <th>Agent Dashboard</th>
                    </tr>
                  </thead>
                  <tbody>
                    {user &&
                      user.map((data, key) => {
                        const canSee =
                          userData?.id == data.Admin_id?.id ||
                          userData?.user_type === 'Admin'
                        if (!canSee) return null

                        // closing_balance is wallet after txn; opening is before
                        const closing =
                          data.closing_balance != null
                            ? Number(data.closing_balance)
                            : null
                        const amt = Number(data.amount) || 0
                        const isCredit = data.status !== 'Penalty by Admin'
                        const opening =
                          closing == null
                            ? null
                            : isCredit
                              ? closing - amt
                              : closing + amt

                        return (
                          <tr key={data._id || key}>
                            <td>{key + 1}</td>
                            <td>{data?.Admin_id?.Phone}</td>
                            <td>
                              {data?.Admin_id && (
                                <Link
                                  className='btn btn-sm btn-outline-info'
                                  to={`/dashboard/AgentDash/${data?.Admin_id._id}`}
                                >
                                  {data?.Admin_id?.Name}
                                </Link>
                              )}
                            </td>
                            <td>{data.amount}</td>
                            <td>{opening != null ? opening : '—'}</td>
                            <td>{data?.action_by?.Name}</td>
                            <td>{data?.txn_msg}</td>
                            <td
                              style={{
                                color:
                                  data?.status == 'Penalty by Admin'
                                    ? 'red'
                                    : 'black',
                              }}
                            >
                              {data?.status}
                            </td>
                            <td>
                              {data.createdAt ? dateFormat(data.createdAt) : '—'}
                            </td>
                            <td>
                              <Link
                                to={`/dashboard/AgentDash/${data?.Admin_id?._id}`}
                                type='button'
                                className='btn btn-outline-info '
                              >
                                Agent Dashboard
                              </Link>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>

              <div className='mt-4'>
                <ReactPaginate
                  previousLabel={'Previous'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination justify-content-center'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  previousClassName={'page-item'}
                  previousLinkClassName={'page-link'}
                  nextClassName={'page-item'}
                  nextLinkClassName={'page-link'}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  activeClassName={'active'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WalletHistory
